module.exports = __webpack_public_path__ + "img/i_dc.5c545b46.svg";